import './Meditate.scss'
import meditationBackground from '../../../../assets/images/waimakariri.svg'

import React, { useEffect } from 'react'
import { ROUTE_ACTIVITIES_MEDITATION_ALL } from '../../../common/helpers/Paths'
import { PlayerProvider } from '../context/player-context'
import AudioPlayer from '../audio-player/AudioPlayer'

export default function Meditate({ setReturnPath, setHeaderTitle }) {
  useEffect(() => {
    const footer = document.querySelector('.footer')

    setHeaderTitle(null)
    setReturnPath(ROUTE_ACTIVITIES_MEDITATION_ALL)

    // hide footer
    footer?.classList.add('footer--hidden')

    return () => {
      footer?.classList.remove('footer--hidden')
    }
  }, [setHeaderTitle, setReturnPath])

  return (
    <div className='audio-slider-container p-4 p-sm-5 d-flex flex-column align-items-stretch justify-content-between w-100 vh-100'>
      <img
        src={meditationBackground}
        alt='meditation background'
        className='audio-slider-container--background'
        fetchpriority='high'
      />
      <h1 className='mt-md-5 mt-sm-0 mt-3 pt-5 fs-1 text-white'>
        Timed meditation
      </h1>
      <PlayerProvider>
        <AudioPlayer />
      </PlayerProvider>
    </div>
  )
}
